import { render, staticRenderFns } from "./releasePass.vue?vue&type=template&id=45901cc2&scoped=true&"
import script from "./releasePass.vue?vue&type=script&lang=js&"
export * from "./releasePass.vue?vue&type=script&lang=js&"
import style0 from "./releasePass.vue?vue&type=style&index=0&id=45901cc2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45901cc2",
  null
  
)

export default component.exports